import { useCallback, useEffect, useState } from 'react';

export default function useVideoOptions(posterPath, vodPath) {
  const [option, setOption] = useState({
    autoplay: true,
    muted: true,
    controls: false,
    crossorigin: 'anonymous',
    loop: true,
    poster: posterPath,
    src: vodPath,
    playsinline: true,
    role: 'application',
  });

  const handleOption = useCallback((key, value) => setOption(prev => ({ ...prev, [key]: value })), [option]);

  useEffect(() => {
    setOption(prev => ({ ...prev, ['poster']: posterPath, ['src']: vodPath }));
  }, [posterPath, vodPath]);

  return [option, handleOption];
}
